import React, {forwardRef} from "react";
import DrawerContent from "../../components/DrawerContent/DrawerContent";

/**
 * The area displayed at the top of the drawer.
 */
const DrawerHeader = forwardRef(({children, className, ...rest}, ref) => (
  <DrawerContent ref={ref} className={className} {...rest}>
    {children}
  </DrawerContent>
));

export default DrawerHeader;
